import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export const dreamupGenerationSucceeded = createAction(`${actionKey}.GENERATION_SUCCEEDED`, (generationId, deviationIds)=>({
        generationId,
        deviationIds
    }));
export const dreamupGenerationFailed = createAction(`${actionKey}.GENERATION_FAILED`, (generationId, errorCode)=>({
        generationId,
        errorCode
    }));
export const dreamupUpscaleSucceeded = createAction(`${actionKey}.UPSCALE_SUCCEEDED`, (generationId, deviationIds)=>({
        generationId,
        deviationIds
    }));
export const dreamupUpscaleFailed = createAction(`${actionKey}.UPSCALE_FAILED`, (generationId, errorCode)=>({
        generationId,
        errorCode
    }));

//# sourceMappingURL=actions.js.map